import React,{useEffect, useState, useContext} from 'react';
import {MyContext} from '../../login/MyContext';

import Inicio from '../inicio/Inicio';

import MaterialTable from 'material-table';
import 'bootstrap/dist/css/bootstrap.min.css';
import {Modal, ModalBody, ModalFooter, ModalHeader} from 'reactstrap';
import axios from 'axios';

import Routes from '../../routes/Routes';


function Categorias() {
  
  const baseUrlAd = Routes.global.url_categorias; 
  const [data, setData]=useState([]);
  const [modalInsertar, setModalInsertar]=useState(false);
  const [modalEditar, setModalEditar]=useState(false);
  const [modalEliminar, setModalEliminar]=useState(false);
  const [frameworkSeleccionado, setFrameworkSeleccionado]=useState({
    id_categoria:'',
    nombre_categoria:'',
    descripcion:''
  });

   
  const handleChange=e=>{
    const {name, value}=e.target;
    setFrameworkSeleccionado((prevState)=>({
      ...prevState,
      [name]: value
    }))
   console.log(frameworkSeleccionado);
  }

  const abrirCerrarModalInsertar=()=>{
    setModalInsertar(!modalInsertar);
  }

  const peticionGet =async() =>{
    await axios.get(baseUrlAd)
    .then(response=>{
     setData(response.data);
    }).catch(error=>{
      console.log(error);
    })

  }

  const peticionPost = async() =>{
    var f = new FormData();
    f.append("nombre_categoria", frameworkSeleccionado.nombre_categoria);
    f.append("descripcion", frameworkSeleccionado.descripcion);
    f.append("METHOD", "POST_categoria");
    await axios.post(baseUrlAd,f)
    .then(response=>{
     setData(data.concat(response.data));
     abrirCerrarModalInsertar();
    }).catch(error=>{
      console.log(error);
    })

  }

  const peticionPut = async() =>{
    var f = new FormData();
    f.append("nombre_categoria", frameworkSeleccionado.nombre_categoria);
    f.append("descripcion", frameworkSeleccionado.descripcion);
    f.append("METHOD", "PUT_categoria");
    await axios.post(baseUrlAd,f, {params: {id_categoria: frameworkSeleccionado.id_categoria}})
    .then(response=>{
     var dataNueva = data;
     dataNueva.map(framework=>{
       if(framework.id_categoria===frameworkSeleccionado.id_categoria){
         framework.nombre_categoria= frameworkSeleccionado.nombre_categoria;
         framework.descripcion= frameworkSeleccionado.descripcion;
       }
     });
     setData(dataNueva);
     abrirCerrarModalEditar();
    }).catch(error=>{
      console.log(error);
    })

  }

  const abrirCerrarModalEditar=()=>{
    setModalEditar(!modalEditar);
  }

  const abrirCerrarModalEliminar=()=>{
    setModalEliminar(!modalEliminar);
  }



  const peticionDelete = async() =>{
    var f = new FormData();
    f.append("METHOD", "DELETE_categoria");
    await axios.post(baseUrlAd,f, {params: {id_categoria: frameworkSeleccionado.id_categoria}})
    .then(response=>{
     setData(data.filter(framework=>framework.id_categoria!==frameworkSeleccionado.id_categoria));
     abrirCerrarModalEliminar();
    }).catch(error=>{
      console.log(error);
    })

  }

  const seleccionarFramework=(framework, caso)=>{
    setFrameworkSeleccionado(framework);
    (caso==="Editar")?
    abrirCerrarModalEditar():
    abrirCerrarModalEliminar()
  } 

  useEffect(()=>{
    const interval = setInterval(() => { 
       peticionGet();  
     }, 1000);
   return () => setInterval(interval);
   },[])

  

  
  const columnas =[
    {
      title:"ID",
      field: "id_categoria",
      
    },
    {
      title:'NOMBRE',
      field:'nombre_categoria'
    },

    {
      title:'DESCRIPCIÓN',
      field:'descripcion'
    },

  ];

  const {rootState,logoutUser} = useContext(MyContext);
  const {isAuth,theUser,showLogin} = rootState;

  if(isAuth && theUser.rol =="usuario")
  {

    return (

        <div className="content-wrapper">
    
    <div className="content-header">
      <div className="container-fluid">
        <div className="row mb-2">
          <div className="col-sm-6">
            <h3 className="m-0"><button className="btn btn-primary" onClick={()=>abrirCerrarModalInsertar()}><i class="fas fa-plus-circle"></i> CREAR CATEGORIA</button></h3>
          </div>
          <div className="col-sm-6">
            
          </div>
        </div>
      </div>
    </div>

   
    <section className="content">
      <div className="container-fluid">
        
        <div className="row">
        
          <div className="col-md-12">

         
            <div>
              
            <MaterialTable   
     
columns={columnas}
data={data}
title="CATEGORIAS"
backIconButtonText='Página anterior'
pagination
fixedHeader

actions={[
    
    {
        icon : 'edit',
        tooltip: 'Editar',
        onClick: (event, framework)=>seleccionarFramework(framework, "Editar")
    },

    {
       icon : 'delete',
       tooltip: 'Eliminar',
       onClick: (event, framework)=>seleccionarFramework(framework, "Eliminar")
    }
]}
options={{
  actionsColumnIndex: -1
}}
options={{
 actionsCellStyle: {
 },

 headerStyle: { backgroundColor: "#55C3F9",  headerStyle: { position: 'sticky'}, boxShadow:"0 0  0 2px rgb(255,255,255)", color: "white" }
}}
localization={{
    header:{
    actions: 'ACCIONES'
    
  },
  body:{ 
    emptyDataSourceMessage:'No hay registros que mostrar',
    
   },

 
   pagination: {
     firstAriaLabel: 'Primera página',
     firstTooltip: 'Primera página',
     labelDisplayedRows: '{from}-{to} de {count}',
     labelRowsPerPage: 'Filas por página:',
     labelRowsSelect: 'filas',
     lastAriaLabel: 'Ultima página',
     lastTooltip: 'Ultima página',
     nextAriaLabel: 'Pagina siguiente',
     nextTooltip: 'Pagina siguiente',
     previousAriaLabel: 'Pagina anterior',
     previousTooltip: 'Pagina anterior',
   },
   toolbar: {
     searchPlaceholder: 'Buscar',
     searchTooltip: 'Buscar',
     showColumnsAriaLabel: 'Mostrar columnas',
     showColumnsTitle: 'Mostrar columnas',
   },

   
}}

/>

<Modal isOpen={modalInsertar}>
 <ModalHeader><i class="fas fa-plus-circle"></i> CREAR CATEGORIA</ModalHeader>
 <ModalBody>
   <div className="form-group">
   <div className="row">

   <div class="col-12">
     <label>Nombre:</label>
     <br/>
     <input type="text" className="form-control" name="nombre_categoria" onChange={handleChange}/>
     <br/>
     </div>

     <div class="col-12">
     <label>Descripción:</label>
     <br/>
     <input type="text" className="form-control" name="descripcion" onChange={handleChange}/>
     <br/>
     </div>

     </div>
 
   </div>
 </ModalBody>
 <ModalFooter>
   <button className="btn btn-primary" onClick={()=>peticionPost()}>Insertar</button>{" "}
   <button className="btn btn-danger" onClick={()=>abrirCerrarModalInsertar()}>Cancelar</button>
 </ModalFooter>
</Modal>


<Modal isOpen={modalEditar}>
<ModalHeader cssModule={{'modal-title': 'w-100 text-center'}}><i class="fas fa-users-cog" style={{color:"#36BCFE"}}>
 </i> EDITAR CATEGORIA</ModalHeader>
 <ModalBody>
   <div className="form-group">
   <div className="row">
   
     <div class="col-12">
     <label>Nombre:</label>
     <br/>
     <input type="text" className="form-control" name="nombre_categoria" onChange={handleChange}  
     value={frameworkSeleccionado && frameworkSeleccionado.nombre_categoria} />
     <br/>
     </div>
     <div class="col-12">
     <label>Descripción:</label>
     <br/>
     <input type="text" className="form-control" name="descripcion" onChange={handleChange}
     value={frameworkSeleccionado && frameworkSeleccionado.descripcion} />
     <br/>
     </div>
 
   </div>
   </div>
 </ModalBody>
 <ModalFooter>
   <button className="btn btn-primary" onClick={()=>peticionPut()}><i class="fas fa-edit"></i> Editar</button>{" "}
   <button className="btn btn-danger" onClick={()=>abrirCerrarModalEditar()}>Cancelar</button>
 </ModalFooter>
</Modal>

<Modal isOpen={modalEliminar}>
 <ModalBody>
   ¿Estas seguro que deseas eliminar la categoria {frameworkSeleccionado && frameworkSeleccionado.nombre_categoria}?
   </ModalBody>
   <ModalFooter>
     <button className="btn btn-danger"
     onClick={()=>peticionDelete()}
     >
       SI
     </button>
     <button
       className="btn btn-secondary"
       onClick={()=>abrirCerrarModalEliminar()}
       >
         NO
     </button>

   </ModalFooter>
 
</Modal>

            </div>
       
          </div>

         
        </div>   

      </div>
    </section>
   
  </div>
     )
    }
  
    else if(showLogin){
        return "";
    }
    else{
      return <Inicio/>;
    }
    
    }

export default Categorias